<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Drycow Strategy
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <subsection title="Dry Cow Sales" :step-name="stepName" subsection="dry_cow_sales">
        <div>
          <p>Product quantities purchased by season.</p>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Animal ID</th>
                <th>Farm Name</th>
                <th>Product</th>
                <th>Last Season</th>
                <th>This Season</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sale, index) in model.CHARTS.dc_get_drycow_sales" :key="index">
                <td class="text-left">{{ sale['Animal ID'] }}</td>
                <td class="text-left">{{ sale['Farm name'] }}</td>
                <td class="text-left">{{ sale['Product'] }}</td>
                <td class="text-left">{{ sale['qty_ls'] }}</td>
                <td class="text-left">{{ sale['qty_ts'] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'DryCowStrategy',
  mixins: [mixin],
}
</script>
